/**
 * Notify browser when the library is ready
 * @returns {undefined}
 */
const dispatchReadyEvent = () => {
  const aurrReadyEvent = new CustomEvent('aurrReadyEvent');
  window.dispatchEvent(aurrReadyEvent);
};

/**
 * Notify browser when a component is rendered
 * @param {Object} e event parameters
 * @returns {undefined}
 */
const dispatchRenderEvent = ({ element }) => {
  const aurrRenderEvent = new CustomEvent('aurrRenderEvent', {
    detail: {
      element,
    },
  });
  window.dispatchEvent(aurrRenderEvent);
};

/**
 * Notify browser of a user interaction
 * @param {Object} e event parameters
 * @returns {undefined}
 */
const displatchIdentityContextEvent = ({ user }) => {
  const aurrUserContextEvent = new CustomEvent('aurrIdentityContextEvent', {
    detail: {
      user,
    },
  });
  window.dispatchEvent(aurrUserContextEvent);
};

export {
  dispatchReadyEvent,
  dispatchRenderEvent,
  displatchIdentityContextEvent,
};
